import { createSlice } from "@reduxjs/toolkit";
import { ForgetPasswordAction, login, ResetPassword, ResendVerificationEmail } from "./authActions";


const initialState = {
  name: null,
  token: null,
  error: null,
  loading: false,
  isAuthenticated: false,
  email: ''
};


const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logout: (state) => {
      state.name = null
      state.token = null
      state.error = null
      state.loading = false
      state.isAuthenticated = false
    },

    setEmail: (state, { payload }) => {
      state.email = payload
    }
  },
  extraReducers: (builder: any) => {
    builder
      .addCase(login.pending, (state: any) => {
        state.loading = true;
      })
      .addCase(login.fulfilled, (state: any, action: any) => {
        const { id, accessToken,email } = action.payload.data;
        
        localStorage.setItem('token', accessToken);
        localStorage.setItem("id", id);
        localStorage.setItem("email", email);
        state.loading = false
        state.isAuthenticated = true
        state.token = accessToken
        state.email = email;
      })
      .addCase(login.rejected, (state: any, action: any) => {
        state.error = action.payload.error;
        state.loading = false;
      })

  }
});

const forgetPassword = createSlice({
  name: 'forgetPassword',
  initialState,
  reducers: {
  

    
  },
  extraReducers: (builder: any) => {
    builder
      .addCase(ForgetPasswordAction.pending, (state: any) => {
        state.loading = true;
      })
      .addCase(ForgetPasswordAction.fulfilled, (state: any, action: any) => {
      
        state.loading = false
      })
      .addCase(ForgetPasswordAction.rejected, (state: any, action: any) => {
        state.error = action.payload.error;
        state.loading = false;
      })

  }
});

const resetPassword = createSlice({
  name: 'resetPassword',
  initialState,
  reducers: {
  

    
  },
  extraReducers: (builder: any) => {
    builder
      .addCase(ResetPassword.pending, (state: any) => {
        state.loading = true;
      })
      .addCase(ResetPassword.fulfilled, (state: any, action: any) => {
      
        state.loading = false
      })
      .addCase(ResetPassword.rejected, (state: any, action: any) => {
        state.error = action.payload.error;
        state.loading = false;
      })

  }
});

const resendVerification = createSlice({
  name: 'resendVerification',
  initialState,
  reducers: {},
  extraReducers: (builder: any) => {
    builder
      .addCase(ResendVerificationEmail.pending, (state: any) => {
        state.loading = true;
      })
      .addCase(ResendVerificationEmail.fulfilled, (state: any) => {
        state.loading = false;
      })
      .addCase(ResendVerificationEmail.rejected, (state: any, action: any) => {
        state.error = action.payload?.error;
        state.loading = false;
      });
  }
});

export const { logout, setEmail } = authSlice.actions;

export const authReducer = authSlice.reducer;
export const forgetPasswordReducer = forgetPassword.reducer
export const resetPasswordReducer = resetPassword.reducer
export const resendVerificationReducer = resendVerification.reducer;